module.exports = __webpack_public_path__ + "img/bracket-round-right.6f828ef3.svg";